// Client-safe constants + types for validation. No fs imports — safe to
// import from client components.

export const VALIDATION_DIMENSIONS = [
  "active",
  "comfortable",
  "safe",
  "connected",
  "welcoming",
  "ecological",
  "lingering",
  "familyFriendly",
  "culturallyImportant",
] as const;

export type ValidationDimension = (typeof VALIDATION_DIMENSIONS)[number];

export const DIMENSION_LABEL: Record<ValidationDimension, string> = {
  active: "feels socially active",
  comfortable: "feels comfortable",
  safe: "feels safe",
  connected: "feels connected",
  welcoming: "feels welcoming",
  ecological: "feels ecological / natural",
  lingering: "feels good for lingering",
  familyFriendly: "feels family-friendly",
  culturallyImportant: "feels culturally important",
};
